import { Component } from '@angular/core';
import { UserSessionService } from '../../UserSession/user-session.service';

/**
 * Componente que renderiza el dashboard (contenedor)
 */
@Component({
  selector: 'ngx-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent {

  public constructor(
    public  userSessionService: UserSessionService,
  ) {


  }

}
